import styled from 'styled-components'

import { _XS_Normal, mainColors } from '@avantstay/backoffice-core'

import { ColorsConfig } from '../../config/colors'
import { DATE_BORDER_WIDTH, EXTENDED_COLUMN_GAP } from '../../config/contants'
import { extendedColumnWidthVar, firstColumnWidthVar, zIndex } from '../../config/styles'

export const ExtendedColumnsWrapper = styled.div<{
  colorsConfig?: ColorsConfig
  selected?: boolean
  even?: boolean
  width?: number
}>`
  ${({ width }) => extendedColumnWidthVar.set(`${width}px`)};
  position: sticky;
  left: ${firstColumnWidthVar.get()};
  z-index: ${zIndex.homeInfoCell};
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-right: ${DATE_BORDER_WIDTH}px;
  background-color: ${({ even, colorsConfig }) =>
    even ? colorsConfig?.backgroundEven : colorsConfig?.background};

  > * {
    padding: 0 ${EXTENDED_COLUMN_GAP}px;
    border-left: 1px solid ${mainColors.neutralMedium};
  }
`

export const SortIndicatorWrapper = styled.div``

export const IconWrapper = styled.div`
  svg {
    max-width: 16px;
    max-height: 16px;
    min-width: 16px;
    min-height: 16px;
  }
`

export const HeaderWrapper = styled(ExtendedColumnsWrapper)`
  border-width: 1px 0 1px 0;
  border-style: solid;
  border-color: ${mainColors.neutralMedium};
  background: ${mainColors.white};
  ${_XS_Normal};
`

export const ColumnHeaderGroupWrapper = styled.div<{ groupWidth: number }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding: 0 !important;
`

export const ColumnHeaderGroupTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  border-bottom: 1px solid ${mainColors.neutralMedium};
`

export const ColumnHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;

  > * + * {
    border-left: 1px solid ${mainColors.neutralMedium};
  }
`
